/**
 * This is a NavigationRailGroup component. This component displays the NavigationRail as a group rather than as a carousel.
 *
 * @module views/components/NavigationRailGroup
 * @memberof -Common
 */
import './NavigationRailGroup.scss';

import React from 'react';

import PropTypes from 'prop-types';

import { useDeviceInflection } from '@ulta/core/providers/InflectionProvider/InflectionProvider';

import NavigationCard from '../NavigationCard/NavigationCard';

/**
 * Represents a NavigationRailGroup component
 *
 * @method
 * @param {NavigationRailGroupProps} props - React properties passed from composition
 * @returns NavigationRailGroup
 */
export const NavigationRailGroup = function( props ){
  const {
    backgroundColor,
    items,
    outlineOption,
    shopAllLabel,
    shopAllAction
  } = props;

  const { breakpoint } = useDeviceInflection();

  return (
    <ul className='NavigationRailGroup'>
      { shopAllAction && shopAllLabel &&
        <li className='NavigationRailGroup__list-item'
          key={ `NavigationCard-ShopAll` }
        >
          <NavigationCard
            shopAllLabel={ shopAllLabel }
            shopAllAction={ shopAllAction }
            outlineOption={ outlineOption }
            backgroundColor={ backgroundColor }
          />
        </li>
      }
      {
        items?.map( ( item, idx ) => (
          <li className='NavigationRailGroup__list-item'
            key={ `NavigationCard-${item.text}-${idx}` }
          >
            <NavigationCard
              { ...item }
              outlineOption={ outlineOption }
              backgroundColor={ backgroundColor }
            />
          </li>
        ) )
      }
    </ul>
  );
};

/**
 * Property type definitions
 * @typedef NavigationRailGroupProps
 * @type {object}
 * @property {array} items - Sets the items to be displayed as NavigationCards for the rail.
 * @property {string} shopAllLabel - Sets the all shop label.
 * @property {object} shopAllAction - Sets the shop all action.
 */
export const propTypes = {
  items: PropTypes.array,
  shopAllLabel: PropTypes.string,
  shopAllAction: PropTypes.object
};

NavigationRailGroup.propTypes = propTypes;

export default NavigationRailGroup;
